module.exports = __webpack_public_path__ + "img/isamilo_lodge_gallery_4.5a775b70.jpeg";